import { render, staticRenderFns } from "./GeneraLista.vue?vue&type=template&id=c670935a&"
import script from "./GeneraLista.vue?vue&type=script&lang=js&"
export * from "./GeneraLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports